
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { SuccessDialogProps } from './types';
import { cn } from '@/lib/utils';

const SuccessDialog: React.FC<SuccessDialogProps> = ({ 
  open, 
  setOpen, 
  deviceName, 
  onComplete 
}) => {
  // Get the appropriate utility color class based on the page URL
  const getUtilityColors = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('water')) return {
      bg: 'bg-sky-100 dark:bg-sky-900/30',
      text: 'text-sky-600 dark:text-sky-400'
    };
    if (path.includes('gas')) return {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-600 dark:text-amber-400'
    };
    return {
      bg: 'bg-emerald-100 dark:bg-emerald-900/30',
      text: 'text-emerald-600 dark:text-emerald-400'
    };
  };

  const colors = getUtilityColors();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Device Registration Complete</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center py-6">
          <div className={cn(`w-16 h-16 rounded-full flex items-center justify-center mb-4`, colors.bg, colors.text)}>
            <Check className="h-8 w-8" />
          </div>
          <h3 className="text-xl font-semibold mb-2">Success!</h3>
          <p className="text-muted-foreground text-center mb-6">
            {deviceName} has been successfully registered to the system.
          </p>
          <Button onClick={onComplete} className="px-6">
            Return to Devices
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
